<template>
    <div class="pos_settings">
        <div class="form-group" v-for="(key_val,key_name) in basic_params" v-if="key_name.length > 0 && is_text_field(key_name)">
            <info_field
                :f_uniq="key_name"
                :f_type="key_name"
                @change="on_change_value(key_name)"
                :f_title="__t(key_name.toUpperCase())"
                :is_disabled=false
                :f_val="basic_params[key_name]"
                v-model=basic_params[key_name]
            >
            </info_field>
        </div>

        <div class="form-group" v-for="(key_val,key_name) in basic_params" v-if="key_name.length > 0 && is_list_field(key_name)">
            <div class="form-group mt-2" v-if="key_name == 'allowed_locales'">
                <label class="form-label" for="locales_online">
                    {{__t("LOCALES_LIST")}}
                </label>

                <div class="" v-if="locales.length > 0">
                    <v-select v-model="basic_params[key_name]"
                              id="locales_online"
                              class="imc_reasons"
                              :reduce="locale => locale.locale_id"
                              label="market_code"
                              :options="locales"
                              :filterable="false"
                              :multiple="true"
                    >

                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.name }}
                                <div>
                                    <small>
                                        {{option.market_code}}
                                    </small>
                                </div>
                            </div>

                        </template>
                    </v-select>
                </div>
            </div>
        </div>


        <div class="form-group row" >
            <div class="col-lg-4 col-sm-4 col-md-4 col-xs-12 mb-3" v-for="(key_val,key_name) in basic_params" v-if="key_name.length > 0 && !is_text_field(key_name) && key_name != 'id'">
                <div class="form-group mt-2" v-if="key_name == 'percent_type'">
                    <label class="form-label">
                        {{__t('PERCENT_TYPE')}}
                    </label>

                    <div class="input-group flex-nowrap">
                        <b-form-radio-group
                            id="btn-radios-1"
                            @update="on_change_value(key_name)"
                            v-model="basic_params[key_name]"
                            button-variant="outline-primary"
                            :options="[
                                  { text: __t('PERCENT_LABEL'), value: 'percent' },
                                   { text: __t('PERCENT_MINUS'), value: 'percent_minus' },
                                  { text:  __t('FIXED'), value: 'fixed' }
                            ]"
                            name="radios-btn-default"
                            buttons
                        ></b-form-radio-group>
                    </div>
                </div>


                <div v-else>
                    <yes_no
                        v-if="!is_list_field(key_name) && !is_text_field(key_name)"
                        :key="key_name"
                        :title="key_name"
                        @input="on_change_value(key_name)"
                        v-model="basic_params[key_name]"
                    >
                    </yes_no>
                </div>


            </div>
        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select';
import {createHelpers} from "vuex-map-fields";
import yes_no from "../../../../sys/radio/yes_no.vue";
import info_field from "../../../../sys/info_field.vue";

const {mapFields} = createHelpers({
    getterType: 'aggregator/getAggregatorStateField',
    mutationType: 'aggregator/updateAggregatorStateField',
});


export default {
    name: "agr_general_settings",

    components: {
        yes_no,
        vSelect,
        info_field
    },

    created() {
        this.loadLocales();
    },

    data() {
        return {
            locales : [],
        }
    },

    methods: {
        is_valid_key(key_name) {
            return true;
        },

        async loadLocales() {
            this.locales = [];
            api.get('/api/v2/locales').then(({data}) => {
                if (data.status === 'operation_success') {
                    this.locales = data.data;
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        is_text_field(key_name) {
            if (this.params_type.hasOwnProperty(key_name)) {
                if (key_name == 'percent_type') {
                    return false;
                }

                let cur_type = this.params_type[key_name];
                return cur_type === 'string';
            }

            return !(key_name === 'id');
        },


        is_list_field(key_name) {
            if (this.params_type.hasOwnProperty(key_name)) {
                let cur_type = this.params_type[key_name];
                return cur_type === 'list';
            }

            return !(key_name === 'id');
        },

        on_change_value(key_name) {
            if (this.basic_params.hasOwnProperty(key_name)) {
                this.$emit('on_change', {
                    'key_name': key_name,
                    'key_val': this.basic_params[key_name],
                    'key_type': "basic",
                })
            }
        },
    },

    computed: {

        basic_params() {
            return this.aggregator_item.basic_params;
        },


        params_type() {
            return this.aggregator_item.params_type;
        },


        ...mapFields([
            'aggregator_item'
        ])
    },
}
</script>

<style scoped>

</style>
